// extracted by mini-css-extract-plugin
export default {"featured-products__title":"FeaturedProducts_featured-products__title__bvOjI"};